// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `links .nav-link {
  display: flex !important;
}
links .nav-label {
  flex-grow: 1;
}
links .nav-caret {
  flex-shrink: 1;
  color: #aaa;
}

.assigned-to {
  white-space: nowrap;
  background-color: #E7F0F8;
  border: 1px solid #C1D9EE;
  display: inline-block;
  color: var(--textColour);
  font-weight: 400;
}
.assigned-to.unassigned {
  background-color: var(--dangerColour);
  border: 1px solid var(--dangerColour);
  color: #fff;
}
.assigned-to .assigned-to-link {
  font-weight: 700;
}

.filter-box {
  padding: 10px 15px !important;
  margin-bottom: 10px;
}

.medium-input .input-group-text {
  padding: 0.1rem 0.5rem !important;
  font-size: 0.875rem !important;
  height: 30px;
}
.medium-input .form-control {
  padding: 0.1rem 0.5rem !important;
  line-height: 1 !important;
  height: 30px;
  font-size: 0.875rem !important;
}

.narrow-input .input-group-text {
  padding: 0.1rem 0.5rem !important;
  font-size: 0.875rem !important;
  height: 26px;
}
.narrow-input .form-control {
  padding: 0.1rem 0.5rem !important;
  line-height: 1 !important;
  height: 26px;
  font-size: 0.875rem !important;
}

#filterValues {
  position: absolute;
  width: 400px;
  background-color: #fff;
  padding: 10px;
  z-index: 999;
  border-radius: 0 3px 3px 0;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
}

#admin-side-nav .side-nav {
  padding-top: var(--totalHeaderHeight) !important;
  width: 200px !important;
  margin-top: 0px !important;
}

#admin-main-panel {
  padding-top: 0 !important;
  margin-right: 0px !important;
  padding-right: 0px !important;
  padding-left: 0px !important;
  margin-left: 0px !important;
}

@media (min-width: 1200px) {
  #admin-main-panel {
    margin-left: 0rem !important;
    padding-left: 13rem !important;
    margin-right: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/admin.component.scss"],"names":[],"mappings":"AAGE;EACE,wBAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAME;EACE,cAAA;EACA,WAAA;AAJJ;;AAQA;EAEE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;AANF;AAQE;EACE,qCAAA;EACA,qCAAA;EACA,WAAA;AANJ;AASE;EACE,gBAAA;AAPJ;;AAWA;EACE,6BAAA;EACA,mBAAA;AARF;;AAaE;EACE,iCAAA;EACA,8BAAA;EACA,YAAA;AAVJ;AAaE;EACE,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;AAXJ;;AAiBE;EACE,iCAAA;EACA,8BAAA;EACA,YAAA;AAdJ;AAiBE;EACE,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;AAfJ;;AAoBA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,0BAAA;EACA,8EAAA;AAjBF;;AAuBE;EACE,gDAAA;EACA,uBAAA;EACA,0BAAA;AApBJ;;AAyBA;EAEE,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;AAvBF;;AA0BA;EAEE;IAEE,4BAAA;IACA,8BAAA;IACA,4BAAA;EAzBF;AACF","sourcesContent":["\nlinks {\n\n  .nav-link {\n    display: flex !important;\n  }\n\n  .nav-label {\n    flex-grow: 1;\n  }\n\n  .nav-caret {\n    flex-shrink: 1;\n    color: #aaa;\n  }\n}\n\n.assigned-to {\n\n  white-space: nowrap;\n  background-color: #E7F0F8;\n  border: 1px solid #C1D9EE;\n  display: inline-block;\n  color: var(--textColour);\n  font-weight: 400;\n\n  &.unassigned {\n    background-color: var(--dangerColour);\n    border: 1px solid var(--dangerColour);\n    color: #fff;\n  }\n\n  .assigned-to-link {\n    font-weight: 700;\n  }\n}\n\n.filter-box {\n  padding: 10px 15px !important;\n  margin-bottom: 10px;\n}\n\n.medium-input {\n\n  .input-group-text {\n    padding: 0.1rem 0.5rem !important;\n    font-size: 0.875rem !important;\n    height: 30px;\n  }\n\n  .form-control {\n    padding: 0.1rem 0.5rem !important;\n    line-height: 1 !important;\n    height: 30px;\n    font-size: 0.875rem !important;\n  }\n}\n\n.narrow-input {\n\n  .input-group-text {\n    padding: 0.1rem 0.5rem !important;\n    font-size: 0.875rem !important;\n    height: 26px;\n  }\n\n  .form-control {\n    padding: 0.1rem 0.5rem !important;\n    line-height: 1 !important;\n    height: 26px;\n    font-size: 0.875rem !important;\n  }\n}\n\n\n#filterValues {\n  position: absolute;\n  width: 400px;\n  background-color: #fff;\n  padding: 10px;\n  z-index: 999;\n  border-radius: 0 3px 3px 0;\n  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);\n\n}\n\n#admin-side-nav {\n\n  .side-nav {\n    padding-top: var(--totalHeaderHeight) !important;\n    width: 200px !important;\n    margin-top: 0px !important;\n  }\n}\n\n\n#admin-main-panel {\n\n  padding-top: 0 !important;\n  margin-right: 0px !important;\n  padding-right: 0px !important;\n  padding-left: 0px !important;\n  margin-left: 0px !important;\n}\n\n@media (min-width: 1200px) {\n\n  #admin-main-panel {\n\n    margin-left: 0rem !important;\n    padding-left: 13rem !important;\n    margin-right: 0px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
